import {MyHospitalizationFlowEnum} from 'presentation/constants';
import React, {Fragment} from 'react';
import {useLocation} from 'react-router-dom';
import {RequestExams} from './components/RequestExams';
import {ResultsReleased} from './components/ResultsReleased';

export const MyHospitalizationExams = () => {
	const {pathname} = useLocation();
	const isRequestedExams = pathname === MyHospitalizationFlowEnum.REQUESTED_EXAMS;

	return <Fragment>{isRequestedExams ? <RequestExams /> : <ResultsReleased />}</Fragment>;
};
